module.exports = __webpack_public_path__ + "img/ad1.9053b1f8.png";